export class AddressRequest {
	public countryCode: string;

	constructor(code: string) {
		this.countryCode = code;
	}
}
